<template>
	<div id="cashierDone">
		<div class="purchasedBox">
			<template
				v-if="isPuchased"
			>
				<h2>ご購入ありがとうございました</h2>

				<div class="reciptWrapper">
					<ul>
						<li
							v-for="item in items"
							:key="item.jan"
						>
							<p>
								{{ item.name }} x {{ item.quantity }}
							</p>
							<p class="price">
								{{ item.price_without_tax }}円
								<small class="internalTax">(税抜)</small>
							</p>
						</li>
					</ul>
					<div class="border"></div>
					<div
						v-if="subtotal.reducedTaxSubject !== 0"
					>
						<div class="subtotalWrapper flex">
							<div class="subtotal">
								小計（8%対象商品）
							</div>
							<div class="subtotal">
								{{ subtotal.reducedTaxSubject }} 円
							</div>
						</div>
						<div class="subtotalWrapper flex">
							<div class="subtotal">
								消費税等（8%）
							</div>
							<div class="subtotal">
								{{ subtotal.reducedTax }} 円
							</div>
						</div>

					</div>
					<div
						v-if="subtotal.fullTax !== 0"
					>
						<div class="subtotalWrapper flex">
							<div class="subtotal">
								小計（10%対象商品）
							</div>
							<div class="subtotal">
								{{ subtotal.fullTaxSubject }} 円
							</div>
						</div>
						<div class="subtotalWrapper flex">
							<div class="subtotal">
								消費税等（10%）
							</div>
							<div class="subtotal">
								{{ subtotal.fullTax }} 円
							</div>
						</div>
					</div>
					<div class="totalPrice flex">
						<div>合計</div>
						<div>
							{{ computedTotalQuantity }}点 {{ totalPrice.withTax }}円
							<!-- <small class="internalTax">
								(内税 {{ computedInternalTax }}円)
							</small> -->
						</div>
					</div>
				</div>
				<p class="mt18 textNote">
					領収書はログイン時のメールアドレスに送信されます。<br>
					※SNSアカウントでログインされた場合は各SNSで登録されたメールアドレスに送信されます
				</p>
			</template>
		</div>
		<div class="btnWrapper">
			<div class="btn back"
				@click="close()"
			>
				閉じる
			</div>
		</div>
	</div>
</template>

<script>
import _ from 'lodash'
import Mixins from '@/mixins'
import { mapGetters, mapActions } from 'vuex'
import StorageService from '@/services/storage.service'

export default {
	name: 'CashierDone',
	mixins: [
		Mixins.api
	],
	data () {
		return {
			isAvailable: false,
			isPuchased: false,
			items: [],
			totalPrice: {
				withTax: 0,
				withoutTax: 0
			},
			subtotal: {
				reducedTaxSubject: 0,
				reducedTax: 0,
				fullTaxSubject: 0,
				fullTax: 0
			}
		}
	},
	computed: {
		...mapGetters({
			$_scannedBarcode: 'Product/getScannedBarcode'
		}),
		computedTotalPrice () {
			let check = 0
			_.forEach(this.items, item => {
				const times = item.quantity
				check += Math.floor(item.price_without_tax) * times
			})
			return check
		},
		computedInternalTax () {
			const { withTax, withoutTax } = this.totalPrice
			const internalTax = withTax - withoutTax
			return internalTax
		},
		computedTotalQuantity () {
			let totalQuantity = 0
			_.forEach(this.items, item => {
				totalQuantity += parseInt(item.quantity)
			})
			return totalQuantity
		}
	},
	async created () {
		const isAvailable = await this.checkIsAvailable()

		if (isAvailable) {
			await this.getTotalPrice()
			this.showPuchasedBox()
		} else {
			this.noAvailableSession()
		}
	},
	methods: {
		...mapActions({
			productVuex_setScannedBarcode: 'Product/setScannedBarcode'
		}),
		/**
		 * 実際に取引が行われたかを確認
		 * @return {Boolean} isAvailable 有効な取引かどうか
		 */
		async checkIsAvailable () {
			const target = 'transaction'
			const id = this.$route.params.transaction_id
			const transaction = await storageService.get(target)
			const isAvailable = id === transaction
			return isAvailable
		},
		/**
		 * 合計金額を取得
		 */
		async getTotalPrice () {
			this.$store.dispatch('Utility/doshowLoading')
			try {
				const body = this.getValuesForTotalPrice()
				const res = await this.$_apiMixin_postTotalPrice(body)
				this.totalPrice.withTax = res.total_price_with_tax
				this.totalPrice.withoutTax = res.total_price_without_tax
				this.subtotal.reducedTaxSubject = res.subtotal.reduced_tax_subject
				this.subtotal.reducedTax = res.subtotal.reduced_tax
				this.subtotal.fullTaxSubject = res.subtotal.full_tax_subject
				this.subtotal.fullTax = res.subtotal.full_tax
			} catch (error) {
				// [WIP] ここでtoastなどでエラー内容を通知
				// eslint-disable-next-line
				console.error(error)
			} finally {
				this.$store.dispatch('Utility/dohideLoading')
			}
		},
		/**
		 * 合計金額を取得するための商品データを形成
		 * @return {Array} body 合計金額取得のための商品リスト
		 */
		getValuesForTotalPrice (transactionId) {
			const { $_scannedBarcode } = this
			const body = []

			$_scannedBarcode.forEach(_item => {
				const item = {}
				item.jan = _item.jan
				item.quantity = _item.quantity
				body.push(item)
			})
			return body
		},
		/**
		 * 購入ありがとうございました画面を表示
		 * ついでに読み込んでいた商品情報の状態を初期化する
		 */
		async showPuchasedBox () {
			const items = await this.getItems()

			this.items = _.cloneDeep(items.scannedBarcode)

			// 状態を初期化
			await this.clearTransaction()
			await this.clearItems()
			// this.$quagga.setScannedBarcode([])
			this.productVuex_setScannedBarcode([])

			this.$nextTick(() => {
				this.isPuchased = true
			})
		},
		/**
		 * 決済時に生成した文字列を削除
		 */
		async getItems () {
			const target = 'items'
			const items = await storageService.get(target)
			return items
		},
		/**
		 * 決済時に生成した文字列を削除
		 */
		async clearTransaction () {
			const target = 'transaction'
			await storageService.delete(target)
		},
		/**
		 * 読み込んでいた商品の状態を削除
		 */
		async clearItems () {
			const target = 'items'
			await storageService.delete(target)
		},
		/**
		 * 無効なセッションIDが遅れた際の処理
		 */
		noAvailableSession () {
			// this.showMessage()
			this.close()
		},
		/**
		 * 無効な決済であることを通知
		 */
		showMessage () {
			const message = '無効なほげほげです'

			this.$buefy.toast.open({
				duration: 5 * 1000,
				message: message
			})
		},
		/**
		 * 閉じるまたはリダイレクトしての処理
		 */
		close () {
			this.$router.push({ name: 'Cashier' })
		}
	}
}

const storageService = new StorageService()
</script>

<style lang="stylus" scoped>
@import "~@/themes/styles/mixins.styl"

#cashierDone
	text-align center
	position fixed
	width 100%
	height 100%
	top 0
	background rgba(0, 0, 0, 0.5)
	z-index 1
	.purchasedBox
		background-color main-bg-dark
		margin-top 10%
		height 95%
		border-top-left-radius 10px
		border-top-right-radius 10px
		padding 24px 6px 60px 6px
		overflow scroll
		> h2
			font-weight 600
			font-size: 20px
		.reciptWrapper
			background-color #fff
			border-radius 6px
			padding 12px
			margin-top 12px
			> ul
				> li
					display flex
					justify-content space-between
					font-size 14px
					p:nth-child(1)
						flex 1
						text-align left
					p:nth-child(2)
						width 33%
						text-align right
					> span
						font-size 12px
			.border
				width 100%
				border-top 1px solid text-super-light
				margin 12px 0
			.totalPrice
				font-size 20px
				padding-top 6px
				justify-content space-between
				font-weight bold
			.subtotalWrapper
				justify-content space-between
				font-size 0.9rem
		.textNote
			text-align left
			font-size 0.9rem
	.btnWrapper
		position fixed
		bottom 0
		left 0
		width 100%
		height 60px
		display flex
		background-color main-bg-dark
		.btn
			background-color black-color
			color #fff
			border 1px solid text-super-light
			border-radius 8px
			margin 6px
			line-height 45px
			flex 1
</style>
